import React, { useCallback, useEffect } from "react";
import logoSuperDucha from "../../../../assets/images/logo-super-tanque.png";
import { TextContainer } from "./ProcessingPaymentStyles";
import { useUnit } from "effector-react";
import {
  GradientContainer,
  LogoSuperDucha,
  LogoWrapper,
  Subtitle,
} from "../../TotemLaundryStyles";
import { LaundryStore, setCieloTransactionId, setErrorMsg, setPage, setPaymentId } from "../../../../stores/LaundryStore/LaundryStore";
import { PAGES } from "../../../../stores/LaundryStore/LaundryStore.types";
import { createTotemTransaction } from "../../../../services/laundryService";
import { getPaymentConfirmation, getPaymentError } from "../../../../services/paymentStatus";

const ProcessingPayment: React.FC = () => {
  const { finalPrice, selectedPayment, totemId } = useUnit(LaundryStore);

  const processPayment = useCallback(async () => {
    if (!selectedPayment?.type || !finalPrice) {
      return;
    }

    const payload = {
      amount: finalPrice.toString(),
      paymentType: selectedPayment?.type,
      totemId,
    };

    const result = await createTotemTransaction(payload);

    if (result.success !== true) {
      handleFailure();
    } else {
      let timeoutId: NodeJS.Timeout;

      const timeout = setTimeout(() => {
        clearTimeout(timeoutId);
        handleTimeout();
      }, 240000);

      const check = async () => {
        try {

          const date = result.data?.timestamp;

          const [responseConfirmation, responseError] = await Promise.all([
            getPaymentConfirmation(totemId, date || ""),
            getPaymentError(totemId, date || ""),
          ]);

          console.log("pooling...", { responseConfirmation, responseError });

          if (responseConfirmation?.id && responseConfirmation?.paymentId) {
            clearTimeout(timeout);
            handleConfirmation(responseConfirmation.paymentId, responseConfirmation.id);
          } else if (responseError?.errorMessage) {
            clearTimeout(timeout);
            handleError(responseError.errorMessage || "Erro desconhecido");
          } else {
            timeoutId = setTimeout(check, 2000);
          }

        } catch (err) {
          console.error("⚠️ Pooling error:", err);
          timeoutId = setTimeout(check, 2000);
        }
      };

      check();

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [finalPrice, selectedPayment?.type, totemId]);

  useEffect(() => {
    processPayment();
  }, [processPayment]);

  const handleConfirmation = (paymentId: string, cieloTransactionId: string) => {
    setPaymentId(paymentId);
    setCieloTransactionId(cieloTransactionId);
    handleSuccess();
  };

  const handleError = (errorMessage: string) => {
    setErrorMsg(errorMessage);
    handleFailure();
  };

  const handleTimeout = () => {
    setErrorMsg("Tempo limite de espera atingido");
    setPage(PAGES.LAUNDRY_PAYMENT_ERROR);
  };

  const handleSuccess = () => {
    setPage(PAGES.CHOOSE_TAX);
  };

  const handleFailure = () => {
    setPage(PAGES.LAUNDRY_PAYMENT_ERROR);
  };

  return (
    <GradientContainer>
      <LogoWrapper>
        <LogoSuperDucha src={logoSuperDucha} alt="Super Ducha" />
      </LogoWrapper>
      <TextContainer>
        <Subtitle fontSize={"2.25rem"}>Processando pagamento...</Subtitle>
      </TextContainer>
    </GradientContainer>
  );
};

export default ProcessingPayment;
